module.exports = __webpack_public_path__ + "media/BANKIER.1efe26bd.mp3";